import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce, isEqual } from 'lodash';
import { getShops } from './selectors';
import ShopList from './components/ShopList';
import Position from '../position/Position';
import { updateFilter, fetchShops } from './actions';
import { fetchAllCities } from '../cities/actions';
import Title from '../components/Title';
import { shopShape, positionShape } from '../shapes';
import Icon, { GLYPHS } from '../components/Icon';
import { clearReservations } from '../reservation/actions';
import analytics from '../applicationServices/analytics/BookingAnalytics';

class Shops extends Component {
  constructor(props) {
    super(props);

    this.fetchShops = debounce(this.props.fetchShops, 250);
  }

  componentWillMount() {
    this.props.clearReservations();
    if (this.hasFilters() || this.hasLocation()) {
      this.fetchShops(this.props);
      return;
    }

    if (this.props.position) this.props.updateFilter(this.props.position);
    this.props.fetchAllCities();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.position, prevProps.position)) {
      this.props.updateFilter(this.props.position);
      return;
    }

    if (this.didUpdateFilter(prevProps)) {
      this.fetchShops(this.props);
    }
  }

  didUpdateFilter(prevProps) {
    const { lat, lng, searchName, city } = this.props;

    const positionChanged = lat !== prevProps.lat || lng !== prevProps.lng;
    const cityChanged = city !== prevProps.city;
    const searchChanged = searchName !== prevProps.searchName;

    return positionChanged || cityChanged || searchChanged;
  }

  hasLocation() {
    return this.props.lat && this.props.lng;
  }

  hasFilters() {
    return this.props.searchName || this.props.city;
  }

  handleCityChange(city) {
    const { lat, lng, searchName } = this.props;
    this.props.updateFilter({ lat, lng, city, searchName });
  }

  handleSearchNameChange(searchName) {
    const { lat, lng, city } = this.props;
    this.props.updateFilter({ lat, lng, city, searchName });
  }

  // eslint-disable-next-line class-methods-use-this
  handleSearchNameFinish(term) {
    if (term !== '') {
      analytics.queryShop({ term });
    }
  }

  isLoadingShopsNearby() {
    return !this.hasFilters() && this.props.shops.length === 0 && this.props.isLoading;
  }

  noShopsNearby() {
    return !this.hasFilters() && this.props.shops.length === 0 && !this.props.isLoading;
  }

  noFilterShops() {
    return this.hasFilters() && this.props.shops.length === 0 && !this.props.isLoading;
  }

  renderShops() {
    const error = (() => {
      if (this.isLoadingShopsNearby()) return 'Loading shops near you...';
      if (this.noShopsNearby()) return 'There are no shops nearby. Please search by name or choose a city.';
      if (this.noFilterShops()) return 'There are no shops that match the search criteria';
      return null;
    })();

    if (error) {
      return (
        <div className="layout u-mt+">
          <div className="layout__item u-1/2-medium-and-up u-1/2-extralarge-and-up u-mb0">
            {error}
          </div>
        </div>
      );
    }

    return <ShopList shops={this.props.shops} isLoading={this.props.isLoading} />;
  }

  render() {
    return (
      <div>
        <Position />
        <Title>Choose a barbershop</Title>
        <div className="layout layout--bottom u-pt+">
          <div className="layout__item u-2/3-large-and-up">
            <div className="c-search">
              <input
                type="text"
                className="c-search__input"
                placeholder="Search by name..."
                value={this.props.searchName}
                onChange={e => this.handleSearchNameChange(e.target.value)}
                onBlur={e => this.handleSearchNameFinish(e.target.value)}
              />
              <Icon className="c-search__icon" glyph={GLYPHS.SEARCH} />
            </div>
          </div>
          <div className="layout__item u-1/3-large-and-up">
            <select
              className="c-select"
              value={this.props.city}
              onChange={e => this.handleCityChange(e.target.value)}
            >
              <option value={'-1'}>City</option>
              {this.props.cities.map(
                city => (<option value={city} key={city}>{city}</option>)
              )}
            </select>
          </div>
        </div>

        {this.renderShops()}
      </div>
    );
  }
}
Shops.propTypes = {
  fetchAllCities: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  fetchShops: PropTypes.func.isRequired,
  shops: PropTypes.arrayOf(shopShape),
  cities: PropTypes.arrayOf(PropTypes.string),
  searchName: PropTypes.string,
  city: PropTypes.string,
  lat: PropTypes.number,
  lng: PropTypes.number,
  position: positionShape,
  isLoading: PropTypes.bool,
  clearReservations: PropTypes.func.isRequired,
};
Shops.defaultProps = {
  shops: [],
  cities: [],
  searchName: '',
  city: '',
  lat: 0,
  lng: 0,
  position: null,
  isLoading: false,
};

function mapStateToProps(state) {
  return {
    shops: getShops(state),
    searchName: state.shops.searchName,
    city: state.shops.city,
    lat: state.shops.lat,
    lng: state.shops.lng,
    cities: state.cities.items,
    position: state.position,
    isLoading: state.shops.isFetching,
  };
}

const dispatchToProps = {
  fetchAllCities,
  updateFilter,
  fetchShops,
  clearReservations,
};

export default connect(mapStateToProps, dispatchToProps)(Shops);



// WEBPACK FOOTER //
// ./src/app/shops/Shops.jsx